export function generateRandomNumber(){
    return Math.floor(((50-5)*Math.random())+5)
}